import apiClient from "../client/apiClient";
import { ENDPOINTS } from "../config/endpoints";
import { normalizeApiError } from "../utils/handleError";
import { unwrapApiResponse } from "../utils/unWrapApiResponse.js";

export const sendBranchTrafficData = async (payload) => {
  try {
    const response = await apiClient.post(ENDPOINTS.BRANCH_TRAFFIC_DATA, payload);
    return unwrapApiResponse(response, {
      extract: "responseData",
      fallbackMessage: "Failed to send branch traffic data",
    });
  } catch (error) {
    throw normalizeApiError(error);
  }
};
